<script>
    export let user
    export let remove

    const url =
        'https://static-cdn.jtvnw.net/jtv_user_pictures/mark_exe-profile_image-f2457594d22a97b7-70x70.jpeg'
</script>

<span
    on:click={() => remove(user)}
    class="mx-1 inline-flex items-center px-4 py-1 rounded-md text-sm font-medium leading-5 bg-indigo-100 text-indigo-800">
    <svg
        class="-ml-0.5 mr-1.5 h-2 w-2 text-indigo-400"
        fill="currentColor"
        viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="3" />
    </svg>
    {user}
</span>

<!-- <div class="chip">
    <img src={url} class="avatar avatar-sm" />
    {user}
    <a
        href="#"
        class="btn btn-clear"
        aria-label="Close"
        role="button"
        on:click={() => remove(user)} />
</div> -->
<style>
    .chip {
        margin-bottom: 0.5rem;
    }
</style>
